// ============================================================================
// Reveal — adds .is-revealed to [data-reveal] elements on scroll-into-view
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        const targets = document.querySelectorAll('[data-reveal]');
        if (!targets.length) return;

        // No IntersectionObserver — reveal everything immediately
        if (typeof IntersectionObserver === 'undefined') {
            targets.forEach(function (el) { el.classList.add('is-revealed'); });
            return;
        }

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                observer.unobserve(entry.target);
            });
        }, {
            root: null,
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.15
        });

        targets.forEach(function (el) { observer.observe(el); });
    });
})(jQuery);
